import { createContext } from 'react';

import { Severity } from '../hooks/snackbar-hook';

export const SnackbarContext = createContext({
  open: (severity: Severity, message: string) => {},
});
